import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { useAuth } from "../lib/auth";
import { formatApiErrorDetail } from "../lib/api";

export default function RegisterPage() {
  const { register } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [name, setName] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true); setError("");
    try {
      // Registration auto-authenticates via httpOnly cookies (no email verification step).
      await register(email, password, name);
      nav("/onboarding");
    } catch (err) {
      setError(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center p-8 bg-[#FAFAFA] text-[#0A0A0A]">
      <form onSubmit={submit} className="w-full max-w-sm" data-testid="register-form">
        <div className="label-caps text-[#0A0A0A] mb-3">Client Access</div>
        <h2 className="font-serif text-3xl font-light mb-8">Create account</h2>

        <label className="label-caps block mb-2">Full name</label>
        <input data-testid="register-name" required value={name} onChange={(e)=>setName(e.target.value)} className="input-dark mb-5"/>

        <label className="label-caps block mb-2">Email</label>
        <input data-testid="register-email" type="email" required value={email} onChange={(e)=>setEmail(e.target.value)} className="input-dark mb-5"/>

        <label className="label-caps block mb-2">Password</label>
        <input data-testid="register-password" type="password" required minLength={6} value={password} onChange={(e)=>setPassword(e.target.value)} className="input-dark mb-6"/>

        {error && <div className="text-sm text-red-600 mb-4">{error}</div>}

        <button data-testid="register-submit" disabled={loading} className="btn-gold w-full disabled:opacity-50">
          {loading ? "Creating…" : "Create Account"}
        </button>
        <div className="text-center text-xs text-[#737373] mt-8">
          Already have an account? <Link to="/login" className="text-[#0A0A0A]">Sign in</Link>
        </div>
      </form>
    </div>
  );
}
